class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.renderDesktopSort(html);
        FacetFiltersForm.renderMobileSortDrawer(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    const parser = new DOMParser();
    const newDocument = parser.parseFromString(html, 'text/html');
    const newContainer = newDocument.getElementById('ProductGridContainer');
    const currentContainer = document.getElementById('ProductGridContainer');
    
    // Preserve the subcategory carousel and filter/sort buttons before updating
    const subcategoryCarousel = currentContainer.querySelector('.subcategory-carousel-wrapper');
    const mobileFilterButtons = currentContainer.querySelector('.mobile-facets-wrapper');
    const mobileProductCount = currentContainer.querySelector('.mobile-product-count');
    const mobileActiveFilters = currentContainer.querySelector('.mobile-active-facets');
    
    // Only remove the new carousel if we have a preserved one to replace it with
    // This prevents losing the carousel when returning from empty state
    if (subcategoryCarousel) {
      const newCarousel = newContainer.querySelector('.subcategory-carousel-wrapper');
      if (newCarousel) {
        newCarousel.remove();
      }
    }
    
    // Update the container
    currentContainer.innerHTML = newContainer.innerHTML;
    
    // Re-insert the preserved subcategory carousel if it existed
    if (subcategoryCarousel) {
      const collectionBanner = currentContainer.querySelector('.collection-hero__text-wrapper');
      if (collectionBanner) {
        collectionBanner.appendChild(subcategoryCarousel);
        
        // Re-initialize Splide carousel if it exists
        const splideElement = subcategoryCarousel.querySelector('.subcategory-splide');
        if (splideElement && typeof Splide !== 'undefined') {
          const itemCount = parseInt(splideElement.getAttribute('data-count')) || 0;
          
          const splide = new Splide('.subcategory-splide', {
            type: 'slide',
            perPage: 5,
            perMove: 1,
            gap: '20px',
            pagination: false,
            arrows: true,
            rewind: false,
            drag: 'free',
            flickPower: 300,
            dragMinThreshold: 10,
            easing: 'ease',
            speed: 400,
            breakpoints: {
              1200: { perPage: 4 },
              991: { perPage: 3 },
              767: { perPage: 2, gap: '15px' },
              480: { perPage: 2, gap: '10px' }
            }
          });
          
          splide.mount();
          
          // Update arrow visibility
          function updateArrowVisibility() {
            const prevArrow = splideElement.querySelector('.splide__arrow--prev');
            const nextArrow = splideElement.querySelector('.splide__arrow--next');
            
            if (!prevArrow || !nextArrow) return;
            
            const currentIndex = splide.index;
            const totalSlides = splide.length;
            const perPage = splide.options.perPage;
            
            if (totalSlides <= perPage) {
              prevArrow.style.display = 'none';
              nextArrow.style.display = 'none';
              return;
            }
            
            if (currentIndex === 0) {
              prevArrow.style.display = 'none';
              nextArrow.style.display = 'flex';
            } else if (currentIndex >= totalSlides - perPage) {
              prevArrow.style.display = 'flex';
              nextArrow.style.display = 'none';
            } else {
              prevArrow.style.display = 'none';
              nextArrow.style.display = 'flex';
            }
          }
          
          updateArrowVisibility();
          splide.on('moved', updateArrowVisibility);
        }
      }
    } else {
      // If no carousel was preserved, initialize any new carousel from the server
      const newSplideElement = currentContainer.querySelector('.subcategory-splide');
      if (newSplideElement && typeof Splide !== 'undefined') {
        const splide = new Splide('.subcategory-splide', {
          type: 'slide',
          perPage: 5,
          perMove: 1,
          gap: '20px',
          pagination: false,
          arrows: true,
          rewind: false,
          drag: 'free',
          flickPower: 300,
          dragMinThreshold: 10,
          easing: 'ease',
          speed: 400,
          breakpoints: {
            1200: { perPage: 4 },
            991: { perPage: 3 },
            767: { perPage: 2, gap: '15px' },
            480: { perPage: 2, gap: '10px' }
          }
        });
        
        splide.mount();
        
        function updateArrowVisibility() {
          const prevArrow = newSplideElement.querySelector('.splide__arrow--prev');
          const nextArrow = newSplideElement.querySelector('.splide__arrow--next');
          
          if (!prevArrow || !nextArrow) return;
          
          const currentIndex = splide.index;
          const totalSlides = splide.length;
          const perPage = splide.options.perPage;
          
          if (totalSlides <= perPage) {
            prevArrow.style.display = 'none';
            nextArrow.style.display = 'none';
            return;
          }
          
          if (currentIndex === 0) {
            prevArrow.style.display = 'none';
            nextArrow.style.display = 'flex';
          } else if (currentIndex >= totalSlides - perPage) {
            prevArrow.style.display = 'flex';
            nextArrow.style.display = 'none';
          } else {
            prevArrow.style.display = 'none';
            nextArrow.style.display = 'flex';
          }
        }
        
        updateArrowVisibility();
        splide.on('moved', updateArrowVisibility);
      }
    }

    // Re-insert preserved mobile filter/sort buttons and update product count/filters from server
    const collectionDiv = currentContainer.querySelector('.collection');
    if (collectionDiv) {
      // Get new product count and active filters from server response
      const newMobileProductCount = currentContainer.querySelector('.mobile-product-count');
      const newMobileActiveFilters = currentContainer.querySelector('.mobile-active-facets');
      
      // Remove new filter buttons from server (we preserve the old ones with event listeners)
      const newMobileFilterButtons = currentContainer.querySelector('.mobile-facets-wrapper');
      if (newMobileFilterButtons) newMobileFilterButtons.remove();
      
      // Re-insert in correct order: count → filter/sort buttons → active filters
      if (newMobileProductCount) {
        collectionDiv.insertBefore(newMobileProductCount, collectionDiv.firstChild);
      }
      if (mobileFilterButtons) {
        if (newMobileProductCount) {
          newMobileProductCount.after(mobileFilterButtons);
        } else {
          collectionDiv.insertBefore(mobileFilterButtons, collectionDiv.firstChild);
        }
        if (newMobileActiveFilters) {
          mobileFilterButtons.after(newMobileActiveFilters);
        }
      } else {
        if (newMobileActiveFilters && newMobileProductCount) {
          newMobileProductCount.after(newMobileActiveFilters);
        }
      }
      
      // Re-attach event listeners to preserved buttons
      FacetFiltersForm.attachMobileButtonListeners();
    }

    currentContainer
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }
  
  static attachMobileButtonListeners() {
    const filterButtons = document.querySelectorAll('[data-mobile-filter-trigger]');
    const filterDrawer = document.querySelector('.mobile-facets__disclosure');
    const sortDrawer = document.querySelector('.mobile-sort__disclosure');
    
    if (filterButtons.length > 0 && filterDrawer && sortDrawer) {
      filterButtons.forEach(function(button, index) {
        // Remove old listeners by cloning and replacing
        const newButton = button.cloneNode(true);
        button.parentNode.replaceChild(newButton, button);
        
        newButton.addEventListener('click', function() {
          // First button is Filter, second button is Sort
          if (index === 0) {
            // Open filter drawer
            const summary = filterDrawer.querySelector('summary');
            if (summary) {
              summary.click();
            }
          } else if (index === 1) {
            // Open sort drawer, anchored under the Sort button
            const rect = newButton.getBoundingClientRect();
            const inner = sortDrawer.querySelector('.mobile-sort__inner');
            if (inner) {
              inner.style.setProperty('--sort-top', `${Math.round(rect.bottom + 4)}px`);
              inner.style.setProperty('--sort-right', `${Math.round(window.innerWidth - rect.right)}px`);
            }
            const summary = sortDrawer.querySelector('summary');
            if (summary) {
              summary.click();
            }
            newButton.classList.toggle('mobile-facets-button--open', sortDrawer.hasAttribute('open'));
          }
        });
      });
    }
  }

  static renderProductCount(html) {
    const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
    const newCountElement = parsedDocument.getElementById('ProductCount');
    if (!newCountElement) return;
    const count = newCountElement.innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));

    const newMobileSeeResultsCount = parsedDocument.getElementById('MobileSeeResultsCount');
    const currentMobileSeeResultsCount = document.getElementById('MobileSeeResultsCount');
    if (newMobileSeeResultsCount && currentMobileSeeResultsCount) {
      currentMobileSeeResultsCount.textContent = newMobileSeeResultsCount.textContent;
    }
  }

  static renderDesktopSort(html) {
    const parser = new DOMParser();
    const newDocument = parser.parseFromString(html, 'text/html');
    
    // Update the custom sort dropdown options
    const newSortPanel = newDocument.querySelector('#CustomSortPanel .custom-sort-panel__options');
    const currentSortPanel = document.querySelector('#CustomSortPanel .custom-sort-panel__options');
    
    if (newSortPanel && currentSortPanel) {
      currentSortPanel.innerHTML = newSortPanel.innerHTML;
      
      // Reinitialize the CustomSortDropdown to restore button click functionality
      if (typeof CustomSortDropdown !== 'undefined') {
        new CustomSortDropdown();
      }
    }
  }

  static renderMobileSortDrawer(html) {
    const parser = new DOMParser();
    const newDocument = parser.parseFromString(html, 'text/html');
    
    // Update mobile sort drawer options (now located in FacetsWrapperMobileSort)
    const newMobileSortList = newDocument.querySelector('#FacetsWrapperMobileSort .mobile-facets__list');
    const currentMobileSortList = document.querySelector('#FacetsWrapperMobileSort .mobile-facets__list');
    
    if (newMobileSortList && currentMobileSortList) {
      currentMobileSortList.innerHTML = newMobileSortList.innerHTML;
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const targetElement = document.querySelector(selector);
      if (!activeFacetsElement || !targetElement) return;
      targetElement.innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      const sourceElement = html.querySelector(selector);
      const targetElement = document.querySelector(selector);
      if (!sourceElement || !targetElement) return;
      targetElement.innerHTML = sourceElement.innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.textInputs = this.querySelectorAll('.price-range__input-text');
    this.sliders = this.querySelectorAll('.price-range__slider');
    this.sliderTrack = this.querySelector('.price-range__slider-track');
    
    this.textInputs.forEach((element) => {
      element.addEventListener('change', this.onTextInputChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    
    this.sliders.forEach((slider) => {
      slider.addEventListener('input', this.onSliderInput.bind(this));
      slider.addEventListener('change', this.onSliderChange.bind(this));
    });
    
    this.setMinAndMaxValues();
    this.updateSliderTrack();
  }

  onTextInputChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
    this.syncTextToSlider(event.currentTarget);
    this.updateSliderTrack();
  }

  onSliderInput(event) {
    const slider = event.currentTarget;
    const type = slider.dataset.type;
    
    const minSlider = this.querySelector('.price-range__slider--min');
    const maxSlider = this.querySelector('.price-range__slider--max');
    
    if (type === 'min') {
      if (parseInt(minSlider.value) > parseInt(maxSlider.value)) {
        minSlider.value = maxSlider.value;
      }
    } else {
      if (parseInt(maxSlider.value) < parseInt(minSlider.value)) {
        maxSlider.value = minSlider.value;
      }
    }
    
    this.syncSliderToText(slider);
    this.updateSliderTrack();
  }

  onSliderChange(event) {
    this.setMinAndMaxValues();
  }

  syncTextToSlider(textInput) {
    const type = textInput.dataset.type;
    const slider = this.querySelector(`.price-range__slider--${type}`);
    if (slider) {
      const cleanValue = textInput.value.replace(/[^\d]/g, '');
      const valueInCents = cleanValue ? Math.round(parseFloat(cleanValue) * 100) : (type === 'min' ? 0 : slider.max);
      slider.value = valueInCents;
    }
  }

  syncSliderToText(slider) {
    const type = slider.dataset.type;
    const textInput = Array.from(this.textInputs).find(input => input.dataset.type === type);
    if (textInput) {
      const valueInDecimal = parseFloat(slider.value) / 100;
      textInput.value = Math.round(valueInDecimal);
    }
  }

  updateSliderTrack() {
    if (!this.sliderTrack) return;
    
    const minSlider = this.querySelector('.price-range__slider--min');
    const maxSlider = this.querySelector('.price-range__slider--max');
    
    if (!minSlider || !maxSlider) return;
    
    const min = parseInt(minSlider.value);
    const max = parseInt(maxSlider.value);
    const rangeMax = parseInt(minSlider.max);
    
    const minPercent = (min / rangeMax) * 100;
    const maxPercent = (max / rangeMax) * 100;
    
    // Use clip-path to show only the active range portion of the track
    this.sliderTrack.style.clipPath = `inset(0 ${100 - maxPercent}% 0 ${minPercent}%)`;
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const minInput = Array.from(this.textInputs).find(input => input.dataset.type === 'min');
    const maxInput = Array.from(this.textInputs).find(input => input.dataset.type === 'max');
    
    if (!minInput || !maxInput) return;
    
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', minInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const cleanValue = input.value.replace(/[^\d]/g, '');
    const value = Number(cleanValue);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

// Handle mobile sort radio button changes
document.addEventListener('change', function(event) {
  if (event.target.classList.contains('mobile-facets__radio')) {
    const form = event.target.closest('form');
    if (form) {
      const facetForm = form.closest('facet-filters-form');
      if (facetForm) {
        const searchParams = facetForm.createSearchParams(form);
        facetForm.onSubmitForm(searchParams, event);
      }
    }
  }
});

// Handle mobile filter and sort button clicks
document.addEventListener('DOMContentLoaded', function() {
  // Attach initial button listeners
  FacetFiltersForm.attachMobileButtonListeners();
  
  // Handle sort radio button selection - close drawer and navigate
  // Use capturing phase to stop the input event from reaching facet-filters-form's AJAX handler
  const mobileSortForm = document.getElementById('FacetSortFormMobile');
  if (mobileSortForm) {
    mobileSortForm.addEventListener('input', function(e) {
      if (e.target.classList.contains('mobile-facets__radio')) {
        e.stopPropagation();
      }
    });
  }

  document.addEventListener('change', function(e) {
    if (e.target.classList.contains('mobile-facets__radio') && 
        e.target.closest('#FacetsWrapperMobileSort')) {
      const sortDrawer = document.querySelector('.mobile-sort__disclosure');
      
      // Close the sort drawer
      if (sortDrawer) {
        const summary = sortDrawer.querySelector('summary');
        if (summary) {
          summary.click();
        }
      }
      
      // Build URL from mobile filter form params + sort value
      const mobileFilterForm = document.getElementById('FacetFiltersFormMobile');
      const url = new URL(window.location.pathname, window.location.origin);
      
      // Collect filter params from mobile filter form
      if (mobileFilterForm) {
        const filterParams = new URLSearchParams(new FormData(mobileFilterForm));
        filterParams.forEach(function(value, key) {
          if (value) url.searchParams.append(key, value);
        });
      }
      
      // Set sort_by param
      url.searchParams.set('sort_by', e.target.value);
      
      // Navigate to new URL
      window.location.href = url.toString();
    }
  });
  
  // Handle overlay click to close sort drawer
  document.addEventListener('click', function(e) {
    const sortDrawer = document.querySelector('.mobile-sort__disclosure');
    if (sortDrawer && sortDrawer.hasAttribute('open')) {
      const sortInner = sortDrawer.querySelector('.mobile-sort__inner');
      // Check if click is outside the sort drawer content
      if (sortInner && !sortInner.contains(e.target) && !e.target.closest('[data-mobile-filter-trigger]')) {
        const summary = sortDrawer.querySelector('summary');
        if (summary) {
          summary.click();
        }
        document.querySelectorAll('.mobile-facets-button--open').forEach(function(button) {
          button.classList.remove('mobile-facets-button--open');
        });
      }
    }
  });

  // The sort dropdown is fixed under the button, so close it when the page scrolls
  window.addEventListener('scroll', function() {
    const sortDrawer = document.querySelector('.mobile-sort__disclosure');
    if (sortDrawer && sortDrawer.hasAttribute('open')) {
      const summary = sortDrawer.querySelector('summary');
      if (summary) summary.click();
      document.querySelectorAll('.mobile-facets-button--open').forEach(function(button) {
        button.classList.remove('mobile-facets-button--open');
      });
    }
  }, { passive: true });
});



